import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68cc38e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "profile__card"
}
const _hoisted_2 = { class: "profile__content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "profile__info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-20" }
const _hoisted_7 = {
  key: 1,
  style: {"margin-bottom":"8px"}
}
const _hoisted_8 = { class: "profile__email" }
const _hoisted_9 = {
  key: 2,
  class: "profile__text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "t.me/", -1))
const _hoisted_11 = { style: {"color":"#EDB94A"} }
const _hoisted_12 = {
  key: 3,
  class: "profile__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_ProfileEditDialog = _resolveComponent("ProfileEditDialog")!
  const _component_AvatarEditDialog = _resolveComponent("AvatarEditDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_center, null, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_q_spinner, {
              key: 0,
              class: "col",
              color: "primary",
              size: "3em",
              thickness: 2
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_avatar, {
              class: "cursor-pointer",
              size: "84px",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAvatarEditDialog = !_ctx.showAvatarEditDialog))
            }, {
              default: _withCtx(() => [
                (!_ctx.affiliate.image)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      style: {"font-size":"84px"},
                      class: "photo",
                      name: "account_circle"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.affiliate.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "photo",
                      src: `${_ctx.storageUrl + '/' + _ctx.affiliate.image}`
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.affiliate.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.affiliate.name), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.affiliate.geo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.affiliate.geo?.name), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.affiliate.credentials.email), 1),
              (_ctx.affiliate.contacts.telegram)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, "@" + _toDisplayString(_ctx.affiliate.contacts.telegram), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.affiliate.contacts.skype)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.affiliate.contacts.skype), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_q_btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showProfileEditDialog = !_ctx.showProfileEditDialog)),
            "no-caps": "",
            outline: "",
            label: _ctx.$t('btn.edit1'),
            color: "primary",
            style: {"width":"100%","max-width":"250px","border-color":"#EDB94A","padding-top":"12px","padding-bottom":"12px"},
            class: "balances__btn profile__btn"
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showProfileEditDialog)
      ? (_openBlock(), _createBlock(_component_ProfileEditDialog, {
          key: 1,
          open: _ctx.showProfileEditDialog,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showProfileEditDialog = false)),
          onRefresh: _ctx.onRequest
        }, null, 8, ["open", "onRefresh"]))
      : _createCommentVNode("", true),
    (_ctx.showAvatarEditDialog)
      ? (_openBlock(), _createBlock(_component_AvatarEditDialog, {
          key: 2,
          open: _ctx.showAvatarEditDialog,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAvatarEditDialog = false)),
          onRefresh: _ctx.onRequest
        }, null, 8, ["open", "onRefresh"]))
      : _createCommentVNode("", true)
  ], 64))
}